<div class="user-form-max-width grid-x grid-margin-x margin-top-large">
    <div class="cell small-12 margin-bottom">
        <input type="file" name="flowDump" id="flowDump" (change)="fileChanged($event.target.files)" />
        <label class="display-inline-block" for="flowDump" #uploadedFiles></label>
        <span>{{uploadFileName}}</span>
    </div>
    <div class="cell small-12 margin-bottom">
        <div class="checkbox">
            <input id="asNew" name="asNew" class="show-for-sr" type="checkbox" [(ngModel)]="importAsNewFlow">
            <label for="asNew" class="inline">
                Import as New Flow
                <span class="checkbox-box" aria-hidden="true" styledCheckbox>
                    <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
                </span>
            </label>
        </div>
    </div>
    <div class="cell small-12 margin-bottom">
        <p class="italic">Checking the 'Import as New Workflow' checkbox will create a new workflow without user/group permissions. Therefore the workflow will have to be assigned to the appropriate group(s) after it is imported.</p>
        <p class="italic">When replacing an existing workflow and leaving the 'Import as New Workflow' checkbox unchecked, the new workflow will retain the appropriate group(s) from the workflow it's replacing. </p>
    </div>
    <div class="cell small-12">
        <label for="newName">New Workflow Name:<input type="text" id="newName" name="newName" [(ngModel)]="newFlowName"/> </label>
    </div>
    <div class="cell small-12 form-button-group">
        <button class="button outline-offset-1" type="submit" (click)="upload()">Upload</button>
    </div>
</div>